export default {
  categoryList: state => state.categoryList,
}
